import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  icon: '🛒',
  number: '01',
  title: 'Hacés el pago',
  description: 'Ingresás tu método de pago. La plataforma detecta tu país y convierte automáticamente el precio a tu moneda local. Podés simular el precio antes de confirmar.'
}, {
  icon: '📥',
  number: '02',
  title: 'Descargás al instante',
  description: 'Recibís acceso inmediato a los 10 archivos PDF. Sin esperar. Sin aplicaciones. Sin suscripción. Desde cualquier dispositivo.'
}, {
  icon: '🌿',
  number: '03',
  title: 'Transformás tu consultorio',
  description: 'Empezás a usar el sistema en tu próxima consulta. Con estructura, criterio clínico y seguridad profesional desde el primer día.'
}];
export function HowItWorks() {
  return <section className="w-full bg-off-white px-5 py-12 sm:py-20" data-id="element-124" data-mp="gr73ifpb8qli">
      <div className="mx-auto max-w-5xl" data-id="element-125" data-mp="14iclp1iq3uyz">
        <div className="mx-auto max-w-2xl text-center" data-id="element-126" data-mp="199uj5fljfdf7">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-slate sm:text-4xl" data-id="element-127" data-mp="19bfev8jl92en">
            ¿Cómo funciona?
          </h2>
          <p className="mt-3 text-sm text-slate/70 sm:text-base" data-id="element-128" data-mp="2mml62u5ded7u">
            Simple, inmediato y desde cualquier país de LATAM
          </p>
        </div>

        <div className="mt-12 flex flex-col gap-8 md:flex-row md:gap-6" data-id="element-129" data-mp="31d24e4mpkn0i">
          {steps.map((step, i) => <React.Fragment key={step.number} data-id="element-130" data-mp="2wj6abd9kfkam" data-mpi={i}>
              <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.45,
            delay: i * 0.1
          }} className="flex flex-1 flex-col items-center text-center" data-id="element-131" data-mp="3abvwpit0ar89">
                <span className="flex h-16 w-16 items-center justify-center rounded-full border border-sage/30 bg-white text-3xl" data-id="element-132" data-mp="3f95xfuluipbe">
                  {step.icon}
                </span>
                <span className="mt-4 font-serif-display text-2xl font-bold text-sage" data-id="element-133" data-mp="1kz2771f8zbgy">
                  {step.number}
                </span>
                <h3 className="mt-2 text-lg font-bold text-slate" data-id="element-134" data-mp="3pya86yqjv4tv">{step.title}</h3>
                <p className="mt-3 max-w-xs text-sm leading-relaxed text-slate/70" data-id="element-135" data-mp="3u05aa5gb1m8p">
                  {step.description}
                </p>
              </motion.div>
              {i < steps.length - 1 && <div className="mx-auto h-8 w-px bg-sage/30 md:hidden" aria-hidden="true" data-id="element-136" data-mp="2rhpbqlz811o" />}
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}